module.exports = __webpack_public_path__ + "img/category.a370de05.svg";